// AccountShellSwitch.tsx — يختار الغلاف المناسب لصفحات الحساب المشتركة (كلمة المرور...)
// (خطة OwnerPortalShell_Plan_2026-07-12.md §B5). مالك صِرف (بلا أي صفحة إداريّة) يرى الصفحة
// داخل بوابته؛ أي حساب آخر (موظّف صِرف أو موظّف-مالك) يراها داخل غلاف الإدارة كالعادة.
// القراءة متزامنة من localStorage (بلا انتظار شبكة) — نفس ضمانة RequirePermission الحاليّة،
// فلا وميض غلاف خاطئ قبل تحميل الصفحة.
import { AppShellLayout } from '../AppShellLayout';
import { OwnerPortalShell } from './OwnerPortalShell';
import { hasAdminPage } from './PortalSwitcher';
import { isHorseOwnerAccount } from '../menuLogic';
import { readJsonStorage } from '../../lib/storage';
import type { Permission } from '../../lib/accessControl';

export function AccountShellSwitch() {
	const isOwnerOnly = isHorseOwnerAccount() && !hasAdminPage(readJsonStorage<Permission[]>('permissions', []));
	return isOwnerOnly ? <OwnerPortalShell /> : <AppShellLayout />;
}
